export default __webpack_public_path__ + "static/media/draughtwebimage.ec081f90.png";